import { Buffer } from 'buffer';
import Utils from '@/utils'

export const useGiftStore = defineStore('gift', {
  state: () => {
    return {
      type: null,
      toName: null,
      toEmail: null,
      fromName: null,
      message: null,
      deliveryDate: null,
      card: {
        amount: null,
        image: null
      },
      pass: null,
      customer: null
    }
  },
  actions: {
    setDetails({ type, cardAmount, cardImage, pass, toName, toEmail, fromName, message, deliveryDate }: any) {
      const sanitizedToEmail = Utils.validation.sanitizeEmail(toEmail)

      this.type = type
      this.card.amount = cardAmount
      this.card.image = cardImage
      this.pass = pass
      this.toName = toName
      this.toEmail = sanitizedToEmail
      this.fromName = fromName
      this.message = message
      this.deliveryDate = deliveryDate
    },
    setCustomer(customer) {
      this.customer = customer
    },
    setCardDetails({ amount, image, toName, toEmail, fromName, message, deliveryDate }) {
      this.setDetails({ type: 'card', cardAmount: amount, cardImage: image, toName, toEmail, fromName, message, deliveryDate })
    },
    setPassDetails({ pass, toName, toEmail, fromName, message, deliveryDate }) {
      this.setDetails({ type: 'pass', pass, toName, toEmail, fromName, message, deliveryDate })
    },
    async setFromUrlQuery(query = {}) {
      const { $api } = useNuxtApp()
      const currentQuery = this.urlQuery

      if (query.gift && currentQuery.gift !== query.gift) {
        const json = Buffer.from(query.gift, 'base64').toString()
        const gift = JSON.parse(json)

        let pass = null
        if (gift.pass && gift.pass.id) {
          if (this.pass && this.pass.id === gift.pass.id) {
            pass = this.pass
          } else {
            const passResult = await $api.pass.pass(gift.pass.id)
            pass = passResult.pass
          }
        }

        this.setDetails({
          type: gift.type,
          cardAmount: (gift.card) ? gift.card.amount : null,
          cardImage: (gift.card) ? gift.card.image : null,
          pass,
          toName: gift.to.name,
          toEmail: gift.to.email,
          fromName: gift.from.name,
          message: gift.message,
          deliveryDate: gift.deliveryDate ?? null
        })
      }

      if (query.customer && currentQuery.customer !== query.customer) {
        const json = Buffer.from(query.customer, 'base64').toString()
        const customer = JSON.parse(json)
        
        this.setCustomer(customer)
      }
    }
  },
  getters: {
    to(state) {
      return {
        name: state.toName,
        email: state.toEmail
      }
    },
    from(state) {
      return {
        name: state.fromName
      }
    },
    urlQuery(state) {
      const query = {}

      const gift = {
        type: state.type,
        to: { name: state.toName, email: state.toEmail },
        from: { name: state.fromName },
        message: state.message,
        deliveryDate: state.deliveryDate ?? null
      }

      if (state.pass && state.pass.id) {
        gift.pass = { id: state.pass.id }
      }
      if (state.card) {
        gift.card = {}

        if (state.card.amount) {
          gift.card.amount = state.card.amount
        }
        if (state.card.image) {
          gift.card.image = state.card.image
        }
      }

      query.gift = Buffer.from(JSON.stringify(gift)).toString('base64')

      if (state.customer) {
        query.customer = Buffer.from(JSON.stringify(state.customer)).toString('base64')
      }

      return query
    }
  }
})
